export default __webpack_public_path__ + "static/media/audio_45_puerta.209e84d8.mp3";